import React from 'react';
import { WorkingCopyKey } from '@amzn/awscat-pattern-library-service-model';
import { withAppContext } from '../../contexts/AppContext';
import { withHelpPanelContext } from '../../contexts/HelpPanelContext';
import ContentData from '../workflow-viewer/content/ContentData';
import PublicationReadonlyContentData from './PublicationReadonlyContentData';
import PublicationEditContentData from './PublicationEditContentData';

class PublicationContentData extends ContentData {
  // @ts-expect-error TS2416 - strict migration
  protected renderReadonlyView = () => {
    return <PublicationReadonlyContentData {...this.props} onEnableEditMode={this.enableEditing} />;
  };

  // @ts-expect-error TS2416 - strict migration
  protected renderEditView = () => {
    return <PublicationEditContentData {...this.props} />;
  };

  protected checkEditingEnabled = async () => {
    const { contentId, contentLastModified, isEditingAllowed } = this.props;
    const workingCopyKey = WorkingCopyKey.finalizingworkingcopy;
    let editingEnabled = isEditingAllowed;
    if (editingEnabled) {
      const mostRecentWorkingCopy = await this.workingCopyMngr.getMostRecentWorkingCopy(
        contentId,
        workingCopyKey,
      );
      if (
        !mostRecentWorkingCopy ||
        !contentLastModified ||
        mostRecentWorkingCopy.createdAt < contentLastModified
      ) {
        editingEnabled = false;
      }
    }
    return editingEnabled;
  };

  protected enableEditing = async () => {
    const { onEnableEditMode } = this.props;
    if (onEnableEditMode) {
      await onEnableEditMode();
    }
    this.setState({
      isEditingEnabled: true,
    });
  };
}

export default withAppContext(withHelpPanelContext(PublicationContentData));
